import { motion } from "framer-motion";

export default function RevealText({ children, delay = 0, className = "" }) {
  return (
    <motion.span
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -10% 0px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      className={`inline-block ${className}`}
    >
      {children}
    </motion.span>
  );
}
